import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {Card, Pagination} from 'antd';

import _ from 'lodash';

import * as actions from '../redux/actions/index';
import HeatMap from "../charts/HeatMap";


class NationalHeatCard extends Component {
  state = {
    page: 1,
    size: 25
  };

  render() {
    const onClick = (stateId, dimension, isAlternate) => {
      this.props.actions.selectState(stateId);

      if (dimension === 'fips') {
        this.props.actions.selectPage('state');
      }
      else if (dimension) {
        this.props.actions.selectField(dimension, isAlternate ? 'y' : 'x');
      }
    };

    return (
      <Card className="NationalHeatCard" noHovering={true} loading={this.props.loading}>
        <h2 className="subtitle">
          National Health Dimensions By State - {this.props.year}<br/>
          <svg width={14} height={8}><rect width={8} height={8} rx={4} ry={4} fill="#e00de0"></rect></svg>
          National Percentile Ranking for State Dimension and Year
        </h2>
        <HeatMap
          data={this.props.data}
          dict={this.props.dict}
          dimensions={this.props.dimensions}
          selectedId={this.props.selectedId}
          dimId={this.props.idField}
          dimLabel={this.props.labelField}
          dimX={this.props.xField}
          dimY={this.props.yField}
          year={this.props.year}
          page={this.state.page}
          size={this.state.size}
          onClick={onClick}
        />
        <Pagination
          size="small"
          style={{position: 'absolute', bottom: 50, right: 120}}
          showSizeChanger
          pageSize={this.state.size}
          current={this.state.page}
          total={_.size(this.props.data)}
          pageSizeOptions={['10', '25', '50', '100']}
          onChange={(page, size) => this.setState({page, size})}
          onShowSizeChange={(current, size) => this.setState({size})}
        />
      </Card>
    );
  }
}

function mapStoreToProps(store, props) {
  return {
    loading: store.states.loadingPct || store.dimensions.loading,
    data: store.states.percentiles,
    dict: store.states.dict,
    dimensions: store.dimensions.fields,
    selectedId: store.states.selected.fips,
    idField: store.dimensions.stateKey,
    labelField: store.dimensions.stateNameKey,
    xField: store.dimensions.xField,
    yField: store.dimensions.yField,
    xLabel: store.dimensions.xLabel,
    yLabel: store.dimensions.yLabel,
    xDesc: store.dimensions.xDesc,
    yDesc: store.dimensions.yDesc,
    year: store.dimensions.year
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  }
}

export default connect(mapStoreToProps, mapDispatchToProps)(NationalHeatCard);



// WEBPACK FOOTER //
// ./src/containers/NationalHeatCard.js